import { render, staticRenderFns } from "./CartButtons.vue?vue&type=template&id=a3bc8c98"
import script from "./CartButtons.vue?vue&type=script&lang=js"
export * from "./CartButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports